// Copyright (C) Microsoft Corporation. All rights reserved.
// @ts-check
const $ = require('jquery');

$(function () {
	$.ajax({
		type: "GET",
		url: "/api/sar/countrylanguage",
		dataType: "json",
		success: function (data: { countries: { id: number, name: string }[], languages: { code: string, name: string}[] }) {
			populateDropdownLists({
				countries: data.countries,
				languages: data.languages
			});
		}
	});
});

$('#country').on('change', function () {
	const countryId: number = $(this).val() as number;
	if (!countryId) return;
	$.getJSON("/api/sar/devices/" + countryId, function (data: { model: string, name: string}[]) {
	loadSarDevices(data);
	});
});

export function populateDropdownLists(countryLanguages: { countries: { id: number, name: string }[], languages: { code: string, name: string }[] }) {
	var countryDropdown = $('#country');
	var languageDropdown = $('#language');
	$.each(countryLanguages.countries, function (_index: number, value: { id: number, name: string }) {
		countryDropdown.append($('<option></option>').val(value.id).text(value.name));
	});
	$.each(countryLanguages.languages, function (_index: number, value: { code: string, name: string }) {
		languageDropdown.append($('<option></option>').val(value.code).text(value.name));
	});
}

export function loadSarDevices(deviceModels: { model: string, name: string }[]) {
	$.each(deviceModels, function (_index: number, value: { model: string, name: string }) {
		$('#device').append($('<option></option>').val(value.model).text(value.name));
	});
}

export function getSarDeviceInfo(countryId: number, languageCode: string, deviceModel: string) {
	if (countryId != null && languageCode != '' && deviceModel != '') {
		$.ajax({
			type: 'GET',
			url: "/api/sar/value/country/" + countryId + "/lang/" + languageCode + "/device/" + deviceModel,
			dataType: 'html',
			success: function (data: string) {
				const element = document.getElementById('sar-document');
				element.replaceChildren();
				placeHtmlInElement(data, element);
			}
		})
	}
}

$('#language, #device').on('change', function () {
	const countryId: number = $('#country').val() as number;
	const languageCode: string = $('#language').val() as string;
	const deviceModel: string = $('#device').val() as string;
	if (countryId && languageCode && deviceModel) {
		getSarDeviceInfo(countryId, languageCode, deviceModel);
	}
});

function placeHtmlInElement(html: string, element: HTMLElement) {
	var parsedHtmlString = new DOMParser().parseFromString(html, "text/html");
	element.append(parsedHtmlString.body);
}
